<template>
  <div class="outer">
    <div class="detail">
      <h3 class="header">{{title}}</h3>
      <p v-for="(item,index) in content" :key="index">{{item}}</p>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      question: [
        // {
        //   title: "如何上传短视频/短视频入口在哪？",
        //   content: [
        //     "1）企业认证用户才能上传短视频，当前功能正在开发中",
        //     "2）若需曝光自己的短视频，请邮件至13794361105@139.com，详细描述操作步骤，我们收到邮件会第一时间联系你"
        //   ]
        // },
        // {
        //   title: "短视频支持多少时间的？",
        //   content: [
        //     "1）APP拍摄上传支持60秒以内的",
        //     "2）APP本地上传支持5分钟以内的",
        //     "3）上述功能正在开发中"
        //   ]
        // },
        {
          title: "为什么视频显示「审核中」/播放量一直为0？",
          content: ["1）系统正在自动审核你的视频，请耐心等待审核结果"]
        },
        {
          title: "视频播放、上传、录制、编辑、保存相关问题？",
          content: [
            "1）出现非正常的操作，建议先切换网络",
            "2）出现非正常的操作，建议先退出账号，重新登录",
            "3）问题得不到解决，请邮件至13794361105@139.com，详细描述操作步骤，我们收到邮件会第一时间联系你"
          ]
        },
        {
          title: "如何删除自己的视频？",
          content: [
            "1）打开自己的视频，播放中有一个转发图标，里面有一个删除功能，点击即可删除"
          ]
        },
        {
          title: "为什么我的视频显示「视频不见啦」？",
          content: ["1）系统检测到有违规内容或多人举报审核之后将被下架"]
        },
        {
          title: "账号（登录、换绑、修改资料、个人主页）相关问题？",
          content: [
            "1）出现非正常的操作，建议先切换网络",
            "2）出现非正常的操作，建议先退出账号，重新登录",
            "3）问题得不到解决，请邮件至13794361105@139.com，详细描述操作步骤，我们收到邮件会第一时间联系你"
          ]
        },
        {
          title: "视频推荐（不感兴趣、推荐重复、总推荐一类）",
          content: [
            "1）推荐内容是根据你的兴趣计算出来的，你可以对不感兴趣的内容进行标记，系统之后将会自动移除该类内容的推荐",
            "2）问题得不到解决，请邮件至13794361105@139.com，详细描述操作步骤，我们收到邮件会第一时间联系你"
          ]
        },
        {
          title: "功能故障",
          content: [
            "1）出现非正常的操作，建议先切换网络",
            "2）出现非正常的操作，建议先退出账号，重新登录",
            "3）问题得不到解决，请邮件至13794361105@139.com，详细描述操作步骤，我们收到邮件会第一时间联系你"
          ]
        },
        {
          title: "举报/合作/侵权",
          content: [
            "1）请邮件至13794361105@139.com，详细描述操作步骤，我们收到邮件会第一时间联系你"
          ]
        }
      ],
      title: "",
      content: ""
    };
  },
  mounted() {
    const id = this.$route.params.id;
    const { question } = this;
    this.title = question[id].title;
    this.content = question[id].content;
  }
};
</script>
<style lang="scss" scoped>
.outer {
  padding: 40px 30px;
  .detail {
    h3 {
      margin-bottom: 12px;
      font-size: 30px;
      color: rgba(1, 1, 1, 1);
      font-weight: bold;
    }
    p {
      // text-align: justify;
      word-break:break-all;
      font-size: 26px;
      font-weight: 400;
      color: rgba(85, 85, 85, 1);
      line-height: 40px;
    }
  }
}
</style>